import {
  Component,
  Injectable,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ComplianceService } from '../../services/compliance.service';
import { UserService } from '../../services/user.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Elementos por página';
  override nextPageLabel = 'Siguiente';
  override previousPageLabel = 'Anterior';
  override firstPageLabel = 'Primera página';
  override lastPageLabel = 'Última página';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  };
}

@Component({
  selector: 'app-compliance-list',
  templateUrl: './compliance-list.component.html',
  styleUrls: ['./compliance-list.component.sass'],
})
export class ComplianceListComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'usuarioId',
    'tipoUsuario',
    'nombre',
    'apellidos',
    'email',
    'tipoId',
    'numeroId',
    'paisResidencia',
    'esPoliticamenteExpuesto',
    'esRTP',
    'esListaONU',
    'estado_compliance',
    'fecha_creacion',
    'fecha_actualizacion',
    'responsable',
    'acciones',
  ];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator | null =
    null;
  columns = [
    {
      columnDef: 'usuarioId',
      header: 'ID',
      cell: (element: any) => `${element.id}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '50px' },
      cellStyle: { 'text-align': 'left', 'font-weight': '600', 'min-width': '50px' },
      isSticky: true,
    },
    {
      columnDef: 'tipoUsuario',
      header: 'Tipo',
      cell: (element: any) => `${element.tipoUsuario}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '90px' },
      cellStyle: { 'text-align': 'left', 'min-width': '90px' },
    },
    {
      columnDef: 'nombre',
      header: 'Nombre',
      cell: (element: any) =>
        `${element.tipoUsuario === 'PERSONA' ? element.nombre : element.razonSocial ? element.razonSocial : 'No registrado'}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '130px' },
      cellStyle: { 'text-align': 'left', 'min-width': '130px' },
    },
    {
      columnDef: 'apellidos',
      header: 'Apellidos',
      cell: (element: any) =>
        `${element.tipoUsuario === 'PERSONA' ? element.apellidos : ''}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '130px' },
      cellStyle: { 'text-align': 'left', 'min-width': '130px' },
    },
    {
      columnDef: 'email',
      header: 'Email',
      cell: (element: any) => `${element.email}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '200px' },
      cellStyle: { 'text-align': 'left', 'min-width': '200px', 'word-break': 'break-all' },
    },
    {
      columnDef: 'tipoId',
      header: 'Tipo Id',
      cell: (element: any) =>
        `${element.tipoUsuario === 'PERSONA' ? element.tipoId : 'RUT Empresa'}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '85px' },
      cellStyle: { 'text-align': 'left', 'min-width': '85px' },
    },
    {
      columnDef: 'numeroId',
      header: 'Documento',
      cell: (element: any) =>
        `${element.tipoUsuario === 'PERSONA' ? element.numeroId : element.rutEmpresa ? element.rutEmpresa : 'No registrado'}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '120px' },
      cellStyle: { 'text-align': 'left', 'min-width': '120px' },
    },
    {
      columnDef: 'paisResidencia',
      header: 'País',
      cell: (element: any) =>
        `${element.paisResidencia ? element.paisResidencia : '-'}`,
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '80px' },
      cellStyle: { 'text-align': 'left', 'min-width': '80px' },
    },
    {
      columnDef: 'esPoliticamenteExpuesto',
      header: 'PEP',
      cell: (element: any) => `${element.esPoliticamenteExpuesto}`,
      headerStyle: { 'text-align': 'center', 'font-weight': 'bold', 'min-width': '50px' },
      cellStyle: { 'text-align': 'center', 'min-width': '50px' },
    },
    {
      columnDef: 'esRTP',
      header: 'RTP',
      cell: (element: any) => `${element.esRTP}`,
      headerStyle: { 'text-align': 'center', 'font-weight': 'bold', 'min-width': '50px' },
      cellStyle: { 'text-align': 'center', 'min-width': '50px' },
    },
    {
      columnDef: 'esListaONU',
      header: 'ONU',
      cell: (element: any) => `${element.esListaONU}`,
      headerStyle: { 'text-align': 'center', 'font-weight': 'bold', 'min-width': '50px' },
      cellStyle: { 'text-align': 'center', 'min-width': '50px' },
    },
    {
      columnDef: 'estado_compliance',
      header: 'Estado',
      cell: (element: any) => {
        switch (element.estadoCompliance) {
          case 'POR APROBAR': return 'report';
          case 'RECHAZADO': return 'cancel';
          case 'BLACK LIST': return 'remove_circle';
          case 'APROBADO': return 'verified_user';
          default: return '';
        }
      },
      headerStyle: { 'text-align': 'center', 'font-weight': 'bold', 'min-width': '80px' },
      cellStyle: { 'text-align': 'center', 'min-width': '80px', display: 'list-item' },
      iconColor: (element: any) => {
        switch (element.estadoCompliance) {
          case 'POR APROBAR': return '#ca8a04';
          case 'RECHAZADO': return '#dc2626';
          case 'BLACK LIST': return '#111827';
          case 'APROBADO': return '#16a34a';
          default: return '';
        }
      },
      val: (element: any) => `${element.estadoCompliance}`,
    },
    {
      columnDef: 'fecha_creacion',
      header: 'Creación',
      cell: (element: any) => {
        try {
          if (element?.log && element.estadoCompliance === 'POR APROBAR') {
            const parsedLog = JSON.parse(element.log);
            return parsedLog.hora
              ? new Date(parsedLog.hora).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
              : 'N/A';
          } else {
            return element?.created_at
              ? new Date(element.created_at).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
              : 'N/A';
          }
        } catch (error) { return 'N/A'; }
      },
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '120px' },
      cellStyle: { 'text-align': 'left', 'min-width': '120px', 'font-size': '0.8rem' },
    },
    {
      columnDef: 'fecha_actualizacion',
      header: 'Actualización',
      cell: (element: any) => {
        try {
          if (element?.log && element.estadoCompliance !== 'POR APROBAR') {
            const parsedLog = JSON.parse(element.log);
            return parsedLog.hora
              ? new Date(parsedLog.hora).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
              : 'N/A';
          } else { return 'N/A'; }
        } catch (error) { return 'N/A'; }
      },
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '120px' },
      cellStyle: { 'text-align': 'left', 'min-width': '120px', 'font-size': '0.8rem' },
    },
    {
      columnDef: 'responsable',
      header: 'Responsable',
      cell: (element: any) => {
        try {
          if (element?.log && element.estadoCompliance !== 'POR APROBAR') {
            const parsedLog = JSON.parse(element.log);
            return parsedLog.responsable ? parsedLog.responsable : 'N/A';
          } else { return 'N/A'; }
        } catch (error) { return 'N/A'; }
      },
      headerStyle: { 'text-align': 'left', 'font-weight': 'bold', 'min-width': '180px' },
      cellStyle: { 'text-align': 'left', 'min-width': '180px', 'word-break': 'break-all' },
    },
  ];
  dataSource: MatTableDataSource<any> | undefined;
  userList = [];
  subscription: Subscription = new Subscription();
  selectedFilter: string = '';
  filters: string[] = ['EMAIL', 'ID'];
  searchValue: string = '';
  defaultPageSize = 25;
  filterOptions: string[] = ['POR APROBAR', 'APROBADO', 'RECHAZADO'];
  constructor(
    private complianceService: ComplianceService,
    private userService: UserService,
    private spinner: SpinnerService,
  ) {
    this.subscription.add(
      this.complianceService
        .getUserComplianceList()
        .subscribe(({ users }: any) => {
          this.dataSource = new MatTableDataSource(users);
          this.userList = users;
          if (this.dataSource) {
            this.dataSource.paginator = this.paginator;
          }
        })
    );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {}

  isColumnSticky(columnDef: string): boolean {
    return columnDef === 'usuarioId' || columnDef === 'email';
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (this.dataSource) {
      this.dataSource.filter = filterValue.trim().toUpperCase();
    }
  }

  public doFilter = (event: any | string) => {
    if (typeof event === 'string') {
      if (this.dataSource) {
        this.dataSource.filter = event.trim().toLocaleLowerCase();
      }
      return;
    }

    const element = (event as KeyboardEvent).currentTarget as HTMLInputElement;
    const value = element.value;
    if (this.dataSource) {
      this.dataSource.filter = value.trim().toLocaleLowerCase();
    }
  };

  editar(row: any) {}

  /** Solo los clientes APROBADOS pueden gestionar pagadores. */
  puedeToggle(row: any): boolean {
    return row?.estadoCompliance === 'APROBADO';
  }

  /** Operador: habilita/deshabilita la creación de pagadores del cliente (con confirmación). */
  async toggleCanAddPayers(row: any, event: Event) {
    event.stopPropagation();
    if (!this.puedeToggle(row)) {
      Swal.fire({
        icon: 'info',
        title: 'Cliente no aprobado',
        text: 'Solo los clientes aprobados pueden gestionar pagadores.',
        confirmButtonColor: '#1e5a3f',
      });
      return;
    }
    const enabled = !row.canAddPayers;
    const confirm = await Swal.fire({
      icon: 'question',
      title: enabled
        ? '¿Habilitar creación de pagadores?'
        : '¿Deshabilitar creación de pagadores?',
      html: `Cliente: <b>${row.email}</b><br>${
        enabled
          ? 'Podrá generar links y registrar pagadores.'
          : 'No podrá crear pagadores ni ver la sección.'
      }`,
      showCancelButton: true,
      confirmButtonText: enabled ? 'Habilitar' : 'Deshabilitar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: enabled ? '#1e5a3f' : '#c0392b',
    });
    if (!confirm.isConfirmed) return;
    const ref = this.spinner.start();
    try {
      await this.userService.setCanAddPayers(row.email, enabled);
      row.canAddPayers = enabled ? 1 : 0;
      this.spinner.stop(ref);
      Swal.fire({
        icon: 'success',
        title: enabled ? 'Habilitado' : 'Deshabilitado',
        timer: 1400,
        showConfirmButton: false,
      });
    } catch (e: any) {
      this.spinner.stop(ref);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: e?.error?.message || 'No se pudo actualizar el permiso.',
        confirmButtonColor: '#1e5a3f',
      });
    }
  }

  // ── Helpers para mobile cards ──
  get currentPageData(): any[] {
    if (!this.dataSource) return [];
    const data = this.dataSource.filteredData;
    if (!this.paginator) return data;
    const start = this.paginator.pageIndex * this.paginator.pageSize;
    return data.slice(start, start + this.paginator.pageSize);
  }

  getStatusIcon(row: any): string {
    switch (row.estadoCompliance) {
      case 'POR APROBAR': return 'report';
      case 'RECHAZADO': return 'cancel';
      case 'BLACK LIST': return 'remove_circle';
      case 'APROBADO': return 'verified_user';
      default: return 'help_outline';
    }
  }

  getStatusColor(row: any): string {
    switch (row.estadoCompliance) {
      case 'POR APROBAR': return '#ca8a04';
      case 'RECHAZADO': return '#dc2626';
      case 'BLACK LIST': return '#111827';
      case 'APROBADO': return '#16a34a';
      default: return '#6b7280';
    }
  }

  getStatusBg(row: any): string {
    switch (row.estadoCompliance) {
      case 'POR APROBAR': return '#fef9c3';
      case 'RECHAZADO': return '#fef2f2';
      case 'BLACK LIST': return '#f3f4f6';
      case 'APROBADO': return '#dcfce7';
      default: return '#f3f4f6';
    }
  }

  getUserName(row: any): string {
    if (row.tipoUsuario === 'PERSONA') {
      return `${row.nombre || ''} ${row.apellidos || ''}`.trim() || 'Sin nombre';
    }
    return row.razonSocial || 'Sin razón social';
  }

  getUserDocument(row: any): string {
    if (row.tipoUsuario === 'PERSONA') return row.numeroId || '-';
    return row.rutEmpresa || '-';
  }

  getDateStr(row: any, field: 'creacion' | 'actualizacion'): string {
    try {
      if (field === 'actualizacion' && row?.log && row.estadoCompliance !== 'POR APROBAR') {
        const p = JSON.parse(row.log);
        return p.hora ? new Date(p.hora).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A';
      }
      if (field === 'creacion') {
        if (row?.log && row.estadoCompliance === 'POR APROBAR') {
          const p = JSON.parse(row.log);
          return p.hora ? new Date(p.hora).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A';
        }
        return row?.created_at ? new Date(row.created_at).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A';
      }
      return 'N/A';
    } catch { return 'N/A'; }
  }

  getResponsable(row: any): string {
    try {
      if (row?.log && row.estadoCompliance !== 'POR APROBAR') {
        const p = JSON.parse(row.log);
        return p.responsable || 'N/A';
      }
      return 'N/A';
    } catch { return 'N/A'; }
  }
}
